var map = {
	"./decidim/avatar-multiuser.png": 53799,
	"./decidim/brands/facebook.svg": 22487,
	"./decidim/brands/google.svg": 63742,
	"./decidim/brands/twitter-x.svg": 86327,
	"./decidim/cc-badge.png": 57613,
	"./decidim/decidim-logo.svg": 49141,
	"./decidim/default-avatar.svg": 19125,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 57419,
	"./decidim/icons.svg": 38372,
	"./decidim/pattern.png": 5303,
	"./decidim/placeholder-card-g.svg": 61644,
	"./decidim/placeholder-card-l.svg": 26967,
	"./decidim/placeholder.jpg": 32334,
	"./decidim/remixicon.symbol.svg": 18916,
	"./decidim/vendor/social-share-button/douban.svg": 29943,
	"./decidim/vendor/social-share-button/email.svg": 98624,
	"./decidim/vendor/social-share-button/facebook.svg": 63836,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 18712,
	"./decidim/vendor/social-share-button/hacker_news.svg": 92916,
	"./decidim/vendor/social-share-button/linkedin.svg": 91430,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 65023,
	"./decidim/vendor/social-share-button/pinterest.svg": 84366,
	"./decidim/vendor/social-share-button/reddit.svg": 72164,
	"./decidim/vendor/social-share-button/telegram.svg": 68585,
	"./decidim/vendor/social-share-button/tumblr.svg": 14534,
	"./decidim/vendor/social-share-button/twitter.svg": 29629,
	"./decidim/vendor/social-share-button/vkontakte.svg": 24223,
	"./decidim/vendor/social-share-button/wechat.svg": 98122,
	"./decidim/vendor/social-share-button/whatsapp.svg": 86890,
	"./decidim/vendor/social-share-button/x.svg": 49696,
	"./decidim/vendor/social-share-button/xing.svg": 14728
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22544;